/** Relay error code returned when a module's OAuth connection needs (re)authorisation. */
const OAUTH_REQUIRED_CODE = 'OAUTH_REQUIRED';

/** Number of retries for a failed module query. */
const MODULE_QUERY_MAX_RETRIES = 2;

/**
 * Default retry policy for module relay queries: retry up to twice, but never
 * when the relay reports that the module's OAuth connection must be authorised
 * first (retrying cannot succeed until the user reconnects).
 *
 * @param failureCount - Number of failed attempts so far
 * @param error - Error from the failed request
 * @returns Whether React Query should retry
 */
export function moduleQueryRetry(failureCount: number, error: unknown): boolean {
  const axiosError = error as { response?: { data?: { code?: string } } };
  if (axiosError?.response?.data?.code === OAUTH_REQUIRED_CODE) return false;
  return failureCount < MODULE_QUERY_MAX_RETRIES;
}
